import type { VFC } from 'react'
import { OpalWordmark } from '@opallabs/beacon'
import { Size } from '@opallabs/gem'
import BikeSeat from './bike-seat.svg'
import Butterfly from './butterfly.svg'
import * as styles from './styles'
import type { SidebarProps } from './types'

export type { SidebarProps }

// Taken from the 1440×900 design file.
const circleSize = Size.Icon * 24.625

export const Sidebar: VFC<SidebarProps> = ({
  headline = 'The future of your brand is built in Opal.',
  theme = 'light',
}) => (
  <aside css={styles.container({ theme })}>
    <BikeSeat aria-hidden={true} css={styles.bikeSeat} />
    <Butterfly aria-hidden={true} css={styles.butterfly} />

    <svg
      aria-hidden
      css={styles.circle({
        size: circleSize,
      })}
      viewBox={`0 0 ${circleSize + 2} ${circleSize + 2}`}
    >
      <circle cx="50%" cy="50%" r={circleSize / 2} />
    </svg>

    <div css={styles.blockStart}>
      <div css={styles.logo}>
        <OpalWordmark includeLogo={true} theme="dark" />
      </div>

      <p css={styles.headline({ theme })}>{headline}</p>

      <div css={styles.spotIllustration} />
    </div>

    <span css={styles.copyright({ theme })}>
      &copy;{new Date().getFullYear()} Opal Labs Inc.
    </span>
  </aside>
)
Sidebar.displayName = 'Ex Astra: Sidebar'
